module.exports = __webpack_public_path__ + "static/gardener-lady-mobile-e48568515a46dcceb615c7cb07f4a0d5.jpg";